import { ScreenReaderInfo } from '@app/components/common/ScreenReaderInfo'
import { Box, CircularProgress, Typography, styled } from '@mui/material'
import { FC } from 'react'

type LoaderProps = {
  announcement?: string
  label?: string
  'aria-hidden'?: boolean
}

const Loader: FC<LoaderProps> = ({ announcement, label, 'aria-hidden': ariaHidden }) => {
  return (
    <>
      {!!announcement && (
        <ScreenReaderInfo ariaLive='assertive' ariaBusy={!announcement}>
          {announcement}
        </ScreenReaderInfo>
      )}

      {label ? (
        <LabeledLoader>
          {/* a11y: decorative spinner — the visible label carries the status */}
          <CircularProgress aria-hidden disableShrink color='primary' />
          {/* a11y: h6 styling without the heading role — a loading status is not a heading */}
          <Typography variant='h6' component='p' color='textSecondary'>
            {label}
          </Typography>
        </LabeledLoader>
      ) : (
        <StyledCircularProgress disableShrink tabIndex={-1} color='primary' aria-hidden={ariaHidden} />
      )}
    </>
  )
}

const LabeledLoader = styled(Box)(
  ({ theme }) => `
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.spacing(4)};
  `,
)

const StyledCircularProgress = styled(CircularProgress)(
  () => `
    position: absolute;
    top: 50%;
    right: 50%;
  `,
)

export default Loader
